import { css } from '@emotion/css';

const styles = {
  productTile: css`
    && > div:last-child {
      height: 100%;
      border-radius: var(--border-radius-400);
    }

    &:has(input:checked) > div:last-child {
      border-color: var(--color-border-brand);
      box-shadow: inset 0 0 0 1px var(--color-border-brand);
    }

    &:has(input:focus-visible) > div:last-child {
      outline: 2px solid var(--color-border-focused);
      outline-offset: var(--spacing-100);
    }

    && input:checked {
      border-color: var(--color-border-brand);
      &::after {
        background: var(--color-background-brand);
      }
    }

    && div:has(> input[type='radio']) {
      padding: var(--spacing-100) 0;
    }

    @media (max-width: 668px) {
      && > div:last-child {
        padding: var(--spacing-400);
      }

      // Keep the native radio keyboard-accessible while saving horizontal space.
      && div:has(> input[type='radio']) {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        overflow: hidden;
        clip-path: inset(50%);
      }

      && [class*='product-selection-card-label'] {
        right: var(--spacing-100);
        max-width: calc(100% - 2 * var(--spacing-100));
      }
    }
  `,
  minimumTerm: css`
    max-width: 13ch;
    color: var(--color-text-weak);
  `,
  mutedText: css`
    color: var(--color-text-weak);
  `,
};

export default styles;
